
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about.description1')}
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {t('about.description2')}
            </p>
            
          </div>
          
          <div className="relative">
            <video
              src="/assets/who.mp4"
              className="rounded-lg shadow-lg object-cover w-full h-[400px]"
              autoPlay
              muted
              loop
              playsInline
              controlsList="nodownload noplaybackrate nofullscreen"
              disablePictureInPicture
            />
          </div>
        </div>
      </div>
    </section>
  );
}
